import * as action from "./action-types";
import * as mutation from "./mutation-types";
import axios from "axios";
import { deepCopyAxiosException } from "@/store/helpers";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";

export const actions = {
  async [action.SAVED_SEARCHES_SAVE]({ state, commit }) {
    commit(mutation.SAVED_SEARCHES_SAVE_STARTED);
    try {
      await axios.put("/api/users/saved-searches", state.savedSearches.data);
      commit(mutation.SAVED_SEARCHES_SAVE_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.SAVED_SEARCHES_SAVE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.SAVED_SEARCHES_GET]({ state, commit }) {
    if (!state.savedSearches.loaded) {
      commit(mutation.SAVED_SEARCHES_GET_STARTED);
      try {
        const { data } = await axios.get("/api/users/saved-searches");
        commit(mutation.SAVED_SEARCHES_GET_SUCCEEDED, data);
        return true;
      } catch (e) {
        commit(mutation.SAVED_SEARCHES_GET_FAILED);
        commit(GLOBAL_ERROR, deepCopyAxiosException(e));
        return false;
      }
    }
  },

  async [action.PINNED_CRITERIA_GET]({ commit, state }) {
    if (!state.pinnedCriteria.loaded) {
      commit(mutation.PINNED_CRITERIA_GET_STARTED);
      try {
        let { data } = await axios.get("/api/users/pinned-search-criteria");
        if (typeof data !== "object") {
          commit(mutation.PINNED_CRITERIA_INITIAL_SETUP);
          data = state.pinnedCriteria.data;
        }
        commit(mutation.PINNED_CRITERIA_GET_SUCCEEDED, data);
        return true;
      } catch (e) {
        commit(mutation.PINNED_CRITERIA_GET_FAILED, deepCopyAxiosException(e));
        return false;
      }
    }
  },
  async [action.PINNED_CRITERIA_SAVE]({ state, commit }) {
    commit(mutation.PINNED_CRITERIA_SAVE_STARTED);
    try {
      await axios.put("/api/users/pinned-search-criteria", state.pinnedCriteria.data);
      commit(mutation.PINNED_CRITERIA_SAVE_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.PINNED_CRITERIA_SAVE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
